import {Component, OnInit, Input, AfterContentChecked, ChangeDetectorRef, forwardRef, OnChanges, SimpleChanges} from '@angular/core';
import { FormBuilder, FormArray, FormGroup, NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { AbwDatasourceColumn, TYPE_DEFAULT_VALUE, Model_WorkflowComponent, FONCTION_WORKFLOW_COMPONENT_OPTIONS, Model_VariableEnvironnement } from 'src/app/app.models';
import { MatTableDataSource } from '@angular/material/table';

@Component({
    selector: 'abw-datasource-columns-mapping',
    templateUrl: './datasource-columns-mapping.component.html',
    styleUrls: ['./datasource-columns-mapping.component.scss'],
    providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => DatasourceColumnsMappingComponent),
        multi: true
      }
    ],
})
export class DatasourceColumnsMappingComponent implements OnInit, AfterContentChecked, ControlValueAccessor {
    @Input() datasourceColumns: AbwDatasourceColumn[] = [];
    @Input() components: Model_WorkflowComponent[] = [];
    @Input() variables: Model_VariableEnvironnement[] = [];
    @Input() value: any;
    @Input() showPK = false;
    displayedColumns = ['PRIMARY_KEY_DATASOURCE', 'DATASOURCE_COLUMN', 'TYPE_DEFAULT_VALUE', 'DEFAULT_VALUE', 'ACTIONS'];
    dataSource = new MatTableDataSource<FormGroup>();
    form = this._formBuilder.group({
        formArray: this._formBuilder.array([])
    });
    TYPE_DEFAULT_VALUE = TYPE_DEFAULT_VALUE;
    PRIMARY_KEY_DATASOURCE = 0;
    FONCTION_WORKFLOW_COMPONENT_OPTIONS = FONCTION_WORKFLOW_COMPONENT_OPTIONS;
    @Input() operators: { VALUE: any, DISPLAY: string }[] = []

    constructor(
        private _formBuilder: FormBuilder,
        private _cdf: ChangeDetectorRef
    ) {
    }

    ngOnInit() {
        this.displayedColumns = this.displayedColumns.filter(c => c != 'PRIMARY_KEY_DATASOURCE' || this.showPK === true);
    }

    ngAfterContentChecked() {
        this._cdf.detectChanges();
    }

    propagateChange = (_: any) => {};
    registerOnChange(fn) { this.propagateChange = fn; }
    registerOnTouched() {}
    writeValue(value: {PRIMARY_KEY: boolean, DATASOURCE_COLUMN: string, DEFAULT_VALUE: number, TYPE_DEFAULT_VALUE: any }[]) {
        if (!!value) {
            this.PRIMARY_KEY_DATASOURCE = value.findIndex(v => v.PRIMARY_KEY === true);
            const rows = value.map(row => this._formBuilder.group({
                DATASOURCE_COLUMN: [row.DATASOURCE_COLUMN],
                TYPE_DEFAULT_VALUE: [row.TYPE_DEFAULT_VALUE],
                DEFAULT_VALUE: [row.DEFAULT_VALUE]
            }));
            this.value = rows; 
            this.dataSource.data = rows;
        }
    }

	onValueChanged() {
        const rows = this.dataSource.data;
        this.value = rows.map(formGroup => formGroup.value);
        this.value.forEach((row, index, rows) => {
            rows[index].PRIMARY_KEY = this.PRIMARY_KEY_DATASOURCE == index;
        })
	  	this.propagateChange(this.value);
        this._cdf.detectChanges();
	}

    addRow() {
        const rows = this.dataSource.data;
        const rowFormGroup = this._formBuilder.group({
            DATASOURCE_COLUMN: [this.datasourceColumns.length > 0 ? this.datasourceColumns[0].name : null],
            TYPE_DEFAULT_VALUE: [this.operators.length > 0 ? this.operators[0].VALUE : null],
            DEFAULT_VALUE: [null]
        });
        rows.push(rowFormGroup);
        this.dataSource.data = rows;
        this.onValueChanged();
    }

    removeRow(index: number) {
        const rows = this.dataSource.data;
        rows.splice(index, 1);
        this.dataSource.data = rows;
        this.onValueChanged();
    }
}